import Basemap from "@arcgis/core/Basemap";
import TileLayer from "@arcgis/core/layers/TileLayer";
import VectorTileLayer from "@arcgis/core/layers/VectorTileLayer";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import ImageryTileLayer from "@arcgis/core/layers/ImageryTileLayer";
import ImageryLayer from "@arcgis/core/layers/ImageryLayer";
import basemapOptions from "../Draggables/Basemap/basemapConfig";
import { BasemapItem, BasemapLayerConfig } from "../../interfaces/config";
import { useStore } from "../../stores/store";

export default function getBasemap(
  selectedBasemapConfig?: BasemapItem | undefined,
  scaleTypeOverride?: string | undefined
) {
  let { scaleType } = useStore.getState();
  if (scaleTypeOverride) {
    scaleType = scaleTypeOverride;
  }

  if (!selectedBasemapConfig) {
    if (!basemapOptions) {
      throw "Basemap configuration invalid";
    }
    selectedBasemapConfig = basemapOptions?.basemaps.find(
      (basemap) => basemap.id === (basemapOptions?.default || "street")
    );
    if (!selectedBasemapConfig) {
      throw "Basemap configuration invalid";
    }
  }
  if (selectedBasemapConfig?.outOfTheBoxBasemap) {
    // If the basemap is an out-of-the-box basemap, return it directly
    return Basemap.fromId(selectedBasemapConfig.outOfTheBoxBasemap);
  }

  if (!selectedBasemapConfig?.basemapLayers) {
    throw "Basemap configuration invalid";
    return null;
  }

  let baseLayers = [] as any;
  if (scaleType === "default") {
    baseLayers = selectedBasemapConfig?.basemapLayers
      .map((basemapData: BasemapLayerConfig | string) => {
        if (typeof basemapData === "string") {
          return new TileLayer({ url: basemapData });
        } else if (basemapData) {
          if (basemapData.type == "tile") {
            return new TileLayer({ url: basemapData.url });
          } else if (basemapData.type == "vector") {
            return new VectorTileLayer({ url: basemapData.url });
          } else if (basemapData.type === "map-image") {
            return new MapImageLayer({ url: basemapData.url, dpi: 96 });
          } else if (basemapData.type === "imagery-tile") {
            return new ImageryTileLayer({ url: basemapData.url });
          } else if (basemapData.type === "imagery") {
            return new ImageryLayer({ url: basemapData.url });
          }
        }
        return null;
      })
      .filter((layer) => layer);
  } else if (scaleType === "scale") {
    baseLayers = selectedBasemapConfig?.scaleBasemapLayers
      ?.map((basemapData: BasemapLayerConfig | string) => {
        if (typeof basemapData === "string") {
          return new TileLayer({ url: basemapData });
        } else if (basemapData) {
          if (basemapData.type == "tile") {
            return new TileLayer({ url: basemapData.url });
          } else if (basemapData.type == "vector") {
            return new VectorTileLayer({ url: basemapData.url });
          } else if (basemapData.type === "map-image") {
            return new MapImageLayer({ url: basemapData.url, dpi: 96 });
          } else if (basemapData.type === "imagery-tile") {
            return new ImageryTileLayer({ url: basemapData.url });
          } else if (basemapData.type === "imagery") {
            return new ImageryLayer({ url: basemapData.url });
          }
        }
        return null;
      })
      .filter((layer) => layer);
  }

  const newBasemap = new Basemap({
    id: selectedBasemapConfig.id,
    title: selectedBasemapConfig.title,
    baseLayers,
    referenceLayers: selectedBasemapConfig.referenceLayers?.map(
      (basemapData: BasemapLayerConfig | string) => {
        if (typeof basemapData === "string") {
          return new TileLayer({ url: basemapData });
        } else if (basemapData) {
          if (basemapData.type == "tile") {
            return new TileLayer({ url: basemapData.url });
          } else if (basemapData.type === "map-image") {
            return new MapImageLayer({ url: basemapData.url, dpi: 96 });
          }
        }
        throw "Basemap configuration invalid";
      }
    ),
  });
  return newBasemap;
}
